import { render, staticRenderFns } from "./ServisniPersonal.vue?vue&type=template&id=785a7632&"
import script from "./ServisniPersonal.vue?vue&type=script&lang=ts&"
export * from "./ServisniPersonal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports